import { useCallback, useEffect, useState } from "react";
import { Pencil, UserPlus } from "lucide-react";
import { api } from "../../lib/api";
import { UserDialog } from "./UserDialog";

export const ROLE_LABEL = { admin: "Admin", purchase_manager: "Purchase Manager", accounts: "Accounts", store: "Showroom / Godown", production: "Job-work / Production" };

export const UsersTab = () => {
  const [users, setUsers] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = useCallback(() => {
    api.get("/users").then((r) => setUsers(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-3" data-testid="users-tab">
      <button className="btn btn-primary w-full" onClick={() => setEditing({})} data-testid="invite-user-btn"><UserPlus size={18} /> Add user</button>
      {users.map((u) => (
        <div key={u.id} className="panel flex items-start gap-3 p-4" data-testid={`user-row-${u.id}`}>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-semibold">{u.name}</span>
              <span className="chip border-border">{ROLE_LABEL[u.role]}</span>
              {!u.active && <span className="chip chip-Cancelled">Disabled</span>}
            </div>
            <p className="break-words text-xs text-muted-foreground">{[u.email, u.mobile].filter(Boolean).join(" · ")}</p>
          </div>
          <button className="icon-btn" onClick={() => setEditing(u)} aria-label="Edit user" data-testid={`user-edit-${u.id}`}><Pencil size={18} /></button>
        </div>
      ))}
      {editing && <UserDialog user={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
};
